const queryOptions = (t) => [
  {
    name: 'orderId',
    displayName: t('queryBuilder.queryParam.queryOptions.query.orderId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'customerName',
    displayName: t('queryBuilder.queryParam.queryOptions.query.customerName'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'deliveryTarget',
    displayName: t('queryBuilder.queryParam.queryOptions.query.deliveryTarget'),
    type: 'deliveryTarget',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('queryBuilder.queryParam.queryOptions.query.createdAt'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'expiration',
    displayName: t('queryBuilder.queryParam.queryOptions.query.expiration'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'statuses',
    displayName: t('queryBuilder.queryParam.queryOptions.query.statuses'),
    type: 'status',
    values: [
      'PENDING',
      'PAID',
      'INVOICED',
      'SHIPPING',
      'DONE',
      'REJECTED_DELIVERY',
      'REJECTED_INVOICE',
      'REJECTED_PAYMENT'
    ],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.PENDING'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.PAID'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.INVOICED'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.SHIPPING'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.DONE'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.REJECTED_DELIVERY'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.REJECTED_INVOICE'),
      t('queryBuilder.queryParam.queryOptions.query.statusesValues.REJECTED_PAYMENT')
    ],
    used: false,
    value: ''
  },
  {
    name: 'invoiceStates',
    displayName: t('queryBuilder.queryParam.queryOptions.query.invoiceStates'),
    type: 'select',
    values: ['NO_INVOICE', 'PARTIAL_INVOICE', 'FAILED_INVOICE', 'INVOICED'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.query.invoiceStatesValues.NO_INVOICE'),
      t('queryBuilder.queryParam.queryOptions.query.invoiceStatesValues.PARTIAL_INVOICE'),
      t('queryBuilder.queryParam.queryOptions.query.invoiceStatesValues.FAILED_INVOICE'),
      t('queryBuilder.queryParam.queryOptions.query.invoiceStatesValues.INVOICED')
    ],
    used: false,
    value: ''
  },
  {
    name: 'sort',
    displayName: t('queryBuilder.queryParam.queryOptions.query.sort.title'),
    type: 'key-value',
    keys: [
      { name: 'id', displayName: t('queryBuilder.queryParam.queryOptions.query.sort.keys.id') },
      {
        name: 'billingInfo.customerName',
        displayName: t('queryBuilder.queryParam.queryOptions.query.sort.keys.billingInfo.customerName')
      },
      { name: 'status', displayName: t('queryBuilder.queryParam.queryOptions.query.sort.keys.status') },
      { name: 'deliveryTarget', displayName: t('queryBuilder.queryParam.queryOptions.query.sort.keys.deliveryTarget') }
    ],
    values: [
      { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.query.sort.values.asc') },
      { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.query.sort.values.desc') }
    ],
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
